"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("rxjs-compat/add/observable/fromPromise");
//# sourceMappingURL=fromPromise.js.map